import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=4b1c2555&scoped=true&slot-scope=scope&"
import script from "./Appeal.vue?vue&type=script&lang=js&"
export * from "./Appeal.vue?vue&type=script&lang=js&"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=4b1c2555&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c2555",
  null
  
)

export default component.exports